<template>
    <div>
        <!-- <div class="top_nav">
            <router-link to="/">
                <div class="nav1">
                    <span>企业简介</span>
                </div>
            </router-link>
            <router-link to="/business">
                <div class="nav2" style="/*border-bottom: 4rem solid #0E6EB8*/">
                    <span>业务范围</span>
                </div>
            </router-link>
            <router-link to="/boutique">
                <div class="nav3">
                    <span>精品工程</span>
                </div>
            </router-link>
        </div> -->
        <div>
            <div style="width: 68%; margin: 20rem auto 50rem; position: absolute; left: 310rem">
                <div class="smtitle">Scope of business</div>
                <div class="bigtitle" style="display: flex; align-items: center; justify-content: space-between">
                    业务范围
                    <div style="margin: auto 0; display: ; /*flex;font-size: 22rem;*/">
                        <!-- <div class="right_icon">&lt;</div>
                        <div class="left_icon">&gt;</div> -->
                        <img src="../../static/images/left-icon.png" style="margin-right: 12rem" />
                        <img src="../../static/images/right2-icon.png" />
                    </div>
                </div>
            </div>
            <el-carousel trigger="click" height="500rem" style="padding-bottom: 14rem" arrow="never">
                <el-carousel-item v-for="(itemarr, index) in datainfo" :key="index" class="carsty">
                    <div v-for="(item, index) in itemarr" :key="index" class="zmousel">
                        <img
                            class="zmousel_img"
                            :src="golaburl + item.address"
                            style="width: 370rem; height: 386rem"
                            @click="godetails(item.id)" />
                        <div class="botmtitle">
                            <div>
                                {{ item.name }}
                                <!-- 详情 -->
                                <!-- <router-link to="/businessdetails"> -->
                                <!-- <img
                                    src="/static/images/right-icon.png"
                                    style="margin-left: 140rem;"
                                    @click="businessdetails(item.id)"
                                /> -->
                                <img
                                    src="../../static/images/right-icon.png"
                                    style="margin-left: 140rem; cursor: pointer"
                                    @click="godetails(item.id)" />
                                <!-- </router-link> -->
                            </div>
                            <div>{{ item.contents }}</div>
                        </div>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
        <!--  -->
    </div>
</template>

<script>
import { getnewindex } from '@/api/api';
import { getdetails } from '@/api/api';

export default {
    data() {
        return {
            golaburl: 'http://39.101.74.19:8717/base-admin',
            datainfo: [],
            ascription: 'businessScope',
        };
    },
    mounted() {
        this.getinfo();
    },
    methods: {
        godetails(id) {
            this.$router.push({ path: '/businessdetails', query: { id } });
            // console.log('id====id==', id);
        },
        group(array, subGroupLength) {
            let index = 0;
            let newArray = [];
            while (index < array.length) {
                newArray.push(array.slice(index, (index += subGroupLength)));
            }
            return newArray;
        },
        // 获取数据
        async getinfo() {
            const res = await getnewindex(this.ascription, 1, 99);
            if (res.code == 200) {
                // console.log('res111===', res);
                this.datainfo = this.group(res.data.slice(), 5);
                // this.datainfo = res.data;
                // console.log('this.datainfo===', this.datainfo);
            }
        },
        // 点击 图标'>'传id
        businessdetails(id) {
            this.$router.push({
                path: '/businessdetails',
                query: {
                    id,
                },
            });
            // console.log('id===============', id);
        },
        // goproduct() {
        //     //查找存储的锚点id
        //     let Id = localStorage.getItem('toId');
        //     let toElement = document.getElementById(Id);
        //     //锚点存在跳转
        //     if (Id) {
        //         toElement.scrollIntoView();
        //     }
        // },
    },
    //用完后记得将存储的锚点置空，否则会影响其他页面跳转到当前页面
    destroyed() {
        localStorage.setItem('toId', '');
    },
};
</script>

<style lang="scss" scoped>
.top_nav {
    background-color: #f4f4f4;
    height: 100rem;
    display: flex;
    justify-content: center;
}
.nav1:hover {
    border-bottom: 4px solid #0e6eb8;
    animation: animate 2s ease-in-out infinite;
    animation-delay: calc(0.1s * var(--i));
    // animation-play-state: paused;
    animation-play-state: running;
}
.nav2:hover {
    border-bottom: 4px solid #0e6eb8;
    animation: animate 2s ease-in-out infinite;
    animation-delay: calc(0.1s * var(--i));
    // animation-play-state: paused;
    animation-play-state: running;
}
.nav3:hover {
    border-bottom: 4px solid #0e6eb8;
    animation: animate 2s ease-in-out infinite;
    animation-delay: calc(0.1s * var(--i));
    // animation-play-state: paused;
    animation-play-state: running;
}
@keyframes animate {
    0%,
    40%,
    100% {
        transform: translateY(0);
    }

    20% {
        transform: translateY(-5px);
    }
}
.nav1 {
    width: 440rem;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #333333;
    font-size: 16rem;
    font-family: Poppins;
    font-weight: bold;
    // line-height: 100rem;
}

.nav1 span {
    width: 100%;
    text-align: center;
    border-right: 1px solid #999999;
}

.nav2 {
    width: 440rem;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #333333;
    font-size: 16rem;
    font-family: Poppins;
    font-weight: bold;
    // line-height: 100rem;
}

.nav2 span {
    width: 100%;
    text-align: center;
    border-right: 1px solid #999999;
}

.nav3 {
    width: 440rem;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #333333;
    font-size: 16rem;
    font-family: Poppins;
    font-weight: bold;
    // line-height: 100rem;
}

.nav3 span {
    width: 100%;
    text-align: center;
}

.detils {
    position: relative;
    height: 388rem;
}

.berich {
    width: 615rem;
    color: rgba(101, 101, 101, 1);
    font-size: 14rem;
    margin-top: 15rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 8;
    line-clamp: 8;
    -webkit-box-orient: vertical;
}

.playimg {
    position: absolute;
    width: 60rem;
    height: 60rem;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 13 !important;
    background-image: url('/static/images/play.png');
}
//
>>> .el-carousel__indicators--horizontal {
    bottom: 98%;
    left: 82%;
    position: absolute;
    z-index: 99999 !important;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    // background-color: pink;
}
>>> .el-carousel--horizontal {
    overflow-x: hidden;
    padding-bottom: 14rem;
    position: relative;
    top: 63rem;
    padding-top: 158rem;
}
>>> .el-carousel__button {
    display: block;
    opacity: 0.48;
    width: 30px;
    height: 0px;
    background-color: #fff;
    border: none;
    outline: 0;
    padding: 0;
    margin: 0;
    cursor: pointer;
    -webkit-transition: 0.3s;
    transition: 0.3s;
}
.spwier_icon:hover {
    background-color: #0e6eb8;
    width: 100rem;
}

.imgsty {
    width: 415rem;
    height: 388rem;
    border-radius: 10rem;
}
.right_icon {
    width: 33rem;
    height: 33rem;
    background-color: #ffffff;
    text-align: center;
    border-radius: 50%;
    border: 1rem solid #1874bb;
    color: #1874bb;
}
.right_icon:hover {
    background-color: #0e6eb8;
    border: 1rem solid #1874bb;
    color: #ffffff;
}
.left_icon {
    width: 33rem;
    height: 33rem;
    margin-left: 12rem;
    text-align: center;
    border-radius: 50%;
    background-color: #ffffff;
    border: 1rem solid #1874bb;
    color: #1874bb;

    // border: 1rem solid #1874bb;
    // color: #ffffff;
}

.left_icon:hover {
    background-color: #0e6eb8;
    border: 1rem solid #1874bb;
    color: #ffffff;
}

.carsty {
    display: flex;
    // justify-content: space-between;
}

.curtain {
    width: 60%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 0 auto;

    &::after {
        content: '';
        width: 370rem;
    }

    > div {
        width: 370rem;
        height: 200rem;
        background: #fff;
        border-radius: 8rem;
        margin-top: 30rem;
        border-radius: 8px;
        padding: 24rem 30rem;
        box-sizing: border-box;
    }
}

.mainbox {
    > div {
        width: 60%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 190rem auto 0;
    }

    > div:nth-child(even) {
        display: flex;
        flex-direction: row-reverse;
    }
}
.carsty {
    display: flex;
    // justify-content: space-between;
    margin-bottom: 14rem;
}
.zmousel {
    position: relative;
    width: 370rem;
    height: 386rem;
    margin-right: 10rem;
    overflow: hidden;

    &:hover > .botmtitle {
        display: block;
        transition: 0.5s ease-in;
    }
}
.zmousel > .zmousel_img {
    cursor: pointer;
    transition: all 0.4s;
}
.zmousel_img:hover {
    transform: scale(1.2);
}
.botmtitle {
    position: absolute;
    left: 0;
    bottom: 0;
    background: #fff;
    display: none;
    width: 100%;
    padding: 25rem 30rem;
    box-sizing: border-box;

    > :first-child {
        color: rgba(51, 51, 51, 1);
        font-size: 25rem;
    }
    > :nth-child(2) {
        color: rgba(101, 101, 101, 1);
        font-size: 15rem;
    }
}
@media screen and (max-width: 800px) {
}
</style>



// WEBPACK FOOTER //
// src/components/business.vue